import React from 'react';
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-800/30 to-transparent">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Process Your Videos?
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
          Start using our professional video processing tools right now. No signup required to get started.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate('/extraction')}
            className="w-full sm:w-auto px-10 py-4 bg-blue-500 hover:bg-blue-600 text-white text-lg font-semibold rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
          >
            Extract Scenes Now →
          </button>
          <button
            onClick={() => navigate('/merge')}
            className="w-full sm:w-auto px-10 py-4 border-2 border-blue-500 hover:bg-blue-500/10 text-blue-400 hover:text-blue-300 text-lg font-semibold rounded-lg transition-all duration-200"
          >
            Merge Videos Now
          </button>
        </div>
        
        {/* Future registration CTA - commented out for now */}
        {/* <div className="mt-8">
          <p className="text-gray-400 text-sm mb-4">
            Want higher limits and premium features?
          </p>
          <button
            disabled
            className="px-6 py-2 bg-purple-500/20 text-purple-300 text-sm font-medium rounded-lg cursor-not-allowed opacity-60"
          >
            Create Account (Coming Soon)
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default CTASection;
